var _circle, _circle2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvatarPlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 32,
    fill: "#E1E7F0"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_608_5954",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 64,
    height: 64
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 32,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_608_5954)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.1503 46.7447C37.8454 47.9643 37.5405 50.7695 38.0284 52.0502C38.2113 52.538 47.6026 56.136 48.7003 56.5629C51.0177 57.4776 53.0911 58.4533 53.9448 59.4291C54.9206 60.5268 55.6524 62.4172 55.6524 64.9175C36.6868 64.9175 26.7466 64.9175 7.78098 64.9175C7.78098 62.4172 8.51277 60.5268 9.4885 59.4291C10.3423 58.4533 12.4157 57.5386 14.733 56.5629C15.8307 56.136 25.222 52.538 25.405 52.0502C25.8928 50.7695 25.5879 47.9643 25.283 46.7447C33.0278 42.7198 30.4665 42.6588 38.1503 46.7447Z",
    fill: "#FFD0CC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.5285 53.2701C40.5285 53.2701 37.9063 56.9901 35.8938 57.173C32.8447 57.478 32.1129 56.5022 30.1005 54.4898C28.393 52.8433 26.3806 50.5869 25.7097 49.0623C25.7097 49.0623 25.3439 46.0132 25.1609 45.5254C24.917 45.0375 30.8323 42.8421 30.8323 42.8421L36.8086 42.7202L38.2112 46.684C38.2112 46.684 37.4794 50.404 38.0892 51.9895L40.5285 53.2701Z",
    fill: "#FFB4AE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.9064 47.9647C32.4789 53.819 30.8324 53.819 25.3439 47.9647C21.746 44.0618 21.0752 39.976 20.8312 35.1583C20.5873 30.8286 19.4286 24.8523 21.8069 21.9861C25.5269 17.5343 37.7234 17.5343 41.4434 21.9861C43.8217 24.8523 42.602 30.8286 42.4191 35.1583C42.1752 39.976 41.5043 44.0618 37.9064 47.9647Z",
    fill: "#FFD9D4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.8679 38.2074C21.8679 38.2074 20.0384 38.7563 18.7578 37.2317C17.4772 35.7071 15.0988 28.5722 20.6482 29.5479L21.8679 38.2074Z",
    fill: "#FFD0CC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.3134 20.2171C38.3134 20.2171 35.6301 24.6688 28.4951 26.9862C21.2992 29.3645 20.8723 38.146 20.8723 38.146C20.8723 38.146 17.8842 35.5847 17.2743 30.95C15.5668 18.0217 23.9215 11.1307 32.1541 11.1307C43.4969 11.0697 47.5827 22.3515 45.6313 31.8038C45.2044 33.8162 44.6555 35.8286 44.1677 36.3775C43.009 37.4752 42.2162 30.2792 42.2162 30.2792C42.2162 30.2792 36.7888 25.0957 38.3134 20.2171Z",
    fill: "#181B21"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.1017 53.0866C42.9679 54.3672 47.9075 56.2577 48.7003 56.5626C51.0176 57.4774 53.091 58.4531 53.9448 59.4288C54.9205 60.5265 55.6523 62.417 55.6523 64.9172C36.6867 64.9172 26.7465 64.9172 7.78091 64.9172C7.78091 62.417 8.5127 60.5265 9.48843 59.4288C10.3422 58.4531 12.4156 57.5383 14.7329 56.5626C15.5257 56.2577 20.5263 54.3063 23.3925 53.0866C24.856 56.5016 28.0271 58.9409 31.6861 58.9409C35.467 58.88 38.6381 56.5016 40.1017 53.0866Z",
    fill: "#FC4C02"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.287 30.4574C42.5309 30.4574 44.0555 28.506 45.1532 29.9695C46.1899 31.4331 44.4824 38.812 42.0431 38.6291C41.9821 38.6291 40.5795 34.7872 42.287 30.4574Z",
    fill: "#FFD9D4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarPlaceholder);
export default __webpack_public_path__ + "static/media/avatar-placeholder.b75cf9ede5eec4b6619bbcf49d08b5c5.svg";
export { ForwardRef as ReactComponent };